import { useState, useRef, useEffect } from "react"
import { Search } from "lucide-react"
import styles from "./ExpandableSearch.module.scss"

type ExpandableSearchProps = {
  value: string
  onChange: (value: string) => void
  placeholder?: string
}

const ExpandableSearch = ({
  value,
  onChange,
  placeholder = "Search...",
}: ExpandableSearchProps) => {
  const [isExpanded, setIsExpanded] = useState(!!value)
  const inputRef = useRef<HTMLInputElement>(null)

  const handleToggle = () => {
    setIsExpanded((prev) => !prev)
  }

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    onChange(e.target.value)
  }

  const handleBlur = () => {
    // Only close if there's no search value
    if (!value.trim()) {
      setIsExpanded(false)
    }
  }

  // Focus input when expanded
  useEffect(() => {
    if (isExpanded && inputRef.current) {
      inputRef.current.focus()
    }
  }, [isExpanded])

  return (
    <div className={`${styles.searchContainer} ${isExpanded ? styles.expanded : styles.collapsed}`}>
      <button
        type="button"
        className={styles.searchButton}
        onClick={handleToggle}
        aria-label="Search"
      >
        <Search size={16} />
      </button>

      <input
        ref={inputRef}
        type="text"
        className={styles.searchInput}
        placeholder={placeholder}
        value={value}
        onChange={handleInputChange}
        onBlur={handleBlur}
      />
    </div>
  )
}

export default ExpandableSearch
